import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardDescription,
} from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '../components/ui/tabs';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../components/ui/table';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Box,
  Typography,
  Chip,
  Paper,
  TableContainer,
  Tab,
  Button as MuiButton,
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions,
} from '@mui/material';
import {
  Truck,
  FileText,
  DollarSign,
  AlertTriangle,
  Upload,
  Eye,
  Plus,
  Search,
  Filter,
  Calendar,
  MapPin,
  Clock,
  CheckCircle,
  XCircle,
  AlertCircle,
  Download,
  Send,
  RefreshCw,
  BarChart3,
  TrendingUp,
  Package,
  Route,
  Fuel,
  Receipt,
  CreditCard,
  FileInvoice,
  Calculator,
  Shield,
  Award,
  Star,
  Users,
  Building,
  Navigation,
  Zap,
  Target,
  PieChart,
  Activity,
  TrendingDown,
  ArrowUpRight,
  ArrowDownRight,
  Minus,
  PlusCircle,
  Edit,
  Trash2,
  MoreHorizontal,
  ExternalLink,
  Copy,
  Share2,
  Bookmark,
  Flag,
  MessageSquare,
  Phone,
  Mail,
  Globe,
  Map,
  Compass,
  Car,
  Bus,
  Train,
  Plane,
  Ship,
  Bike,
  Walk,
  Home,
  Settings,
  User,
  LogOut,
  Bell,
  Menu,
  X,
  ChevronDown,
  ChevronRight,
  ChevronLeft,
  ChevronUp,
  ArrowRight,
  ArrowLeft,
  ArrowUp,
  ArrowDown,
  RotateCcw,
  RotateCw,
  ZoomIn,
  ZoomOut,
  Maximize,
  Minimize,
  Move,
  Crop,
  Type,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  List,
  ListOrdered,
  Quote,
  Code,
  Link,
  Image,
  Video,
  Music,
  File,
  Folder,
  FolderOpen,
  Save,
  SaveAll,
  Download as DownloadIcon,
  Upload as UploadIcon,
  Lock,
  Unlock,
  EyeOff,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Smile,
  Frown,
  Meh,
  Star as StarIcon,
  StarOff,
  Bookmark as BookmarkIcon,
  BookmarkOff,
  Share,
  MessageCircle,
  PhoneCall,
  VideoCall,
  Mail as MailIcon,
  Send as SendIcon,
  Archive,
  ArchiveRestore,
  Trash,
  Undo,
  Redo,
  Cut,
  Copy as CopyIcon,
  Paste,
  Scissors,
  Paperclip,
  Pin,
  PinOff,
  Tag,
  Tags,
  Hash,
  AtSign,
  Percent,
  Infinity,
  Pi,
  Sigma,
  Omega,
  Alpha,
  Beta,
  Gamma,
  Delta,
  Epsilon,
  Zeta,
  Eta,
  Theta,
  Iota,
  Kappa,
  Lambda,
  Mu,
  Nu,
  Xi,
  Omicron,
  Rho,
  Tau,
  Upsilon,
  Phi,
  Chi,
  Psi,
  Omega as OmegaIcon,
} from 'lucide-react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';

const TransportistaDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeItem, setActiveItem] = useState('Dashboard Transportista');
  const [activeTab, setActiveTab] = useState('viajes');
  const [loading, setLoading] = useState(false);
  const [viajes, setViajes] = useState([]);
  const [facturas, setFacturas] = useState([]);
  const [solicitudesPago, setSolicitudesPago] = useState([]);
  const [incidencias, setIncidencias] = useState([]);
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [showSolicitudDialog, setShowSolicitudDialog] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [filtroEstatus, setFiltroEstatus] = useState('todos');
  const [filtroFecha, setFiltroFecha] = useState('todos');

  // Datos de ejemplo para el dashboard
  useEffect(() => {
    // Simular carga de datos
    setLoading(true);
    setTimeout(() => {
      setViajes([
        {
          id: 1,
          numeroViaje: 'VIA-2024-001',
          origen: 'Monterrey, NL',
          destino: 'Guadalajara, JAL',
          fechaInicio: '2024-01-15',
          fechaFin: '2024-01-16',
          estatus: 'completado',
          distancia: '850 km',
          ganancia: '$15,000',
          cliente: 'Empresa ABC',
          tipoCarga: 'Electrónicos',
          peso: '5,000 kg',
          incidencias: 0
        },
        {
          id: 2,
          numeroViaje: 'VIA-2024-002',
          origen: 'Tijuana, BC',
          destino: 'Ciudad de México',
          fechaInicio: '2024-01-17',
          fechaFin: '2024-01-19',
          estatus: 'en_progreso',
          distancia: '2,200 km',
          ganancia: '$28,000',
          cliente: 'Empresa XYZ',
          tipoCarga: 'Automotriz',
          peso: '8,500 kg',
          incidencias: 1
        },
        {
          id: 3,
          numeroViaje: 'VIA-2024-003',
          origen: 'Veracruz, VER',
          destino: 'Mérida, YUC',
          fechaInicio: '2024-01-20',
          fechaFin: null,
          estatus: 'programado',
          distancia: '1,100 km',
          ganancia: '$18,500',
          cliente: 'Empresa DEF',
          tipoCarga: 'Alimentos',
          peso: '3,200 kg',
          incidencias: 0
        }
      ]);

      setFacturas([
        {
          id: 1,
          numero: 'FAC-2024-001',
          fecha: '2024-01-15',
          monto: '$15,000',
          estatus: 'pendiente',
          cliente: 'Empresa ABC',
          viaje: 'VIA-2024-001',
          vencimiento: '2024-02-15'
        },
        {
          id: 2,
          numero: 'FAC-2024-002',
          fecha: '2024-01-17',
          monto: '$28,000',
          estatus: 'aprobada',
          cliente: 'Empresa XYZ',
          viaje: 'VIA-2024-002',
          vencimiento: '2024-02-17'
        }
      ]);

      setSolicitudesPago([
        {
          id: 1,
          numero: 'SOL-2024-001',
          fecha: '2024-01-16',
          monto: '$15,000',
          estatus: 'aprobada',
          factura: 'FAC-2024-001',
          fechaPago: '2024-01-20',
          comision: '$750'
        },
        {
          id: 2,
          numero: 'SOL-2024-002',
          fecha: '2024-01-18',
          monto: '$28,000',
          estatus: 'pendiente',
          factura: 'FAC-2024-002',
          fechaPago: null,
          comision: '$1,400'
        }
      ]);

      setIncidencias([
        {
          id: 1,
          viaje: 'VIA-2024-002',
          fecha: '2024-01-18',
          tipo: 'retraso',
          descripcion: 'Retraso por condiciones climáticas',
          estatus: 'resuelta',
          impacto: '2 horas'
        }
      ]);

      setLoading(false);
    }, 1000);
  }, []);

  const getEstatusColor = (estatus) => {
    switch (estatus) {
      case 'completado':
        return 'bg-green-100 text-green-800';
      case 'en_progreso':
        return 'bg-blue-100 text-blue-800';
      case 'programado':
        return 'bg-yellow-100 text-yellow-800';
      case 'cancelado':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getEstatusText = (estatus) => {
    switch (estatus) {
      case 'completado':
        return 'Completado';
      case 'en_progreso':
        return 'En Progreso';
      case 'programado':
        return 'Programado';
      case 'cancelado':
        return 'Cancelado';
      default:
        return estatus;
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleUploadFactura = () => {
    if (!selectedFile) {
      toast.error('Por favor selecciona un archivo');
      return;
    }
    
    // Simular carga de factura
    toast.success('Factura cargada exitosamente');
    setShowUploadDialog(false);
    setSelectedFile(null);
  };

  const handleSolicitarPago = () => {
    // Simular solicitud de pago
    toast.success('Solicitud de pago enviada exitosamente');
    setShowSolicitudDialog(false);
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login', { replace: true });
  };

  const handleVerViaje = (viajeId) => {
    navigate(`/viaje-detalle/${viajeId}`);
  };

  // Estadísticas del dashboard
  const stats = {
    totalViajes: viajes.length,
    viajesCompletados: viajes.filter(v => v.estatus === 'completado').length,
    viajesEnProgreso: viajes.filter(v => v.estatus === 'en_progreso').length,
    gananciaTotal: viajes.reduce((sum, v) => sum + parseFloat(v.ganancia.replace('$', '').replace(',', '')), 0),
    facturasPendientes: facturas.filter(f => f.estatus === 'pendiente').length,
    solicitudesPendientes: solicitudesPago.filter(s => s.estatus === 'pendiente').length,
    incidenciasAbiertas: incidencias.filter(i => i.estatus !== 'resuelta').length
  };

  return (
    <div className="flex">
      <Sidebar
        isOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        onLogout={handleLogout}
      />

      <div className={`transition-all duration-300 flex-1 ${sidebarOpen ? 'ml-64' : 'ml-16'} bg-gray-100 min-h-screen`}>
        <Topbar showSearch={false} />
        
        <div className="p-6">
          <Helmet>
            <title>Dashboard Transportista | OMS AMERISA</title>
          </Helmet>

          {/* Header */}
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-900">Dashboard Transportista</h1>
            <p className="text-gray-600">Gestiona tus viajes, facturas y solicitudes de pago</p>
          </div>

          {/* Estadísticas principales */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
            <Card>
              <CardContent className="p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Total Viajes</p>
                    <p className="text-2xl font-bold text-gray-900">{stats.totalViajes}</p>
                  </div>
                  <Truck className="h-8 w-8 text-blue-600" />
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Ganancia Total</p>
                    <p className="text-2xl font-bold text-green-600">${stats.gananciaTotal.toLocaleString()}</p>
                  </div>
                  <DollarSign className="h-8 w-8 text-green-600" />
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Facturas Pendientes</p>
                    <p className="text-2xl font-bold text-orange-600">{stats.facturasPendientes}</p>
                  </div>
                  <FileText className="h-8 w-8 text-orange-600" />
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Incidencias</p>
                    <p className="text-2xl font-bold text-red-600">{stats.incidenciasAbiertas}</p>
                  </div>
                  <AlertTriangle className="h-8 w-8 text-red-600" />
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Tabs principales */}
          <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
            <TabsList className="grid w-full grid-cols-4">
              <TabsTrigger value="viajes" className="flex items-center gap-2">
                <Truck className="h-4 w-4" />
                Mis Viajes
              </TabsTrigger>
              <TabsTrigger value="facturas" className="flex items-center gap-2">
                <FileText className="h-4 w-4" />
                Facturas
              </TabsTrigger>
              <TabsTrigger value="pagos" className="flex items-center gap-2">
                <DollarSign className="h-4 w-4" />
                Solicitudes de Pago
              </TabsTrigger>
              <TabsTrigger value="incidencias" className="flex items-center gap-2">
                <AlertTriangle className="h-4 w-4" />
                Incidencias
              </TabsTrigger>
            </TabsList>

            {/* Tab: Mis Viajes */}
            <TabsContent value="viajes" className="space-y-6">
              <Card>
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <div>
                      <CardTitle>Mis Viajes</CardTitle>
                      <CardDescription>
                        Gestiona y revisa el estado de todos tus viajes
                      </CardDescription>
                    </div>
                    <div className="flex gap-2">
                      <FormControl size="small" sx={{ minWidth: 160 }}>
                        <InputLabel>Filtrar por estatus</InputLabel>
                        <Select
                          value={filtroEstatus}
                          onChange={(e) => setFiltroEstatus(e.target.value)}
                          label="Filtrar por estatus"
                        >
                          <MenuItem value="todos">Todos</MenuItem>
                          <MenuItem value="completado">Completados</MenuItem>
                          <MenuItem value="en_progreso">En Progreso</MenuItem>
                          <MenuItem value="programado">Programados</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Número de Viaje</TableHead>
                        <TableHead>Origen - Destino</TableHead>
                        <TableHead>Fecha</TableHead>
                        <TableHead>Estatus</TableHead>
                        <TableHead>Ganancia</TableHead>
                        <TableHead>Cliente</TableHead>
                        <TableHead>Acciones</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {viajes.map((viaje) => (
                        <TableRow key={viaje.id}>
                          <TableCell className="font-medium">{viaje.numeroViaje}</TableCell>
                          <TableCell>
                            <div className="space-y-1">
                              <div className="text-sm">{viaje.origen}</div>
                              <div className="text-sm text-gray-500">→ {viaje.destino}</div>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="space-y-1">
                              <div className="text-sm">{viaje.fechaInicio}</div>
                              {viaje.fechaFin && (
                                <div className="text-sm text-gray-500">- {viaje.fechaFin}</div>
                              )}
                            </div>
                          </TableCell>
                          <TableCell>
                            <Badge className={getEstatusColor(viaje.estatus)}>
                              {getEstatusText(viaje.estatus)}
                            </Badge>
                          </TableCell>
                          <TableCell className="font-medium text-green-600">
                            {viaje.ganancia}
                          </TableCell>
                          <TableCell>{viaje.cliente}</TableCell>
                          <TableCell>
                            <div className="flex gap-2">
                              <Button variant="outline" size="sm" onClick={() => handleVerViaje(viaje.id)}>
                                <Eye className="h-4 w-4" />
                              </Button>
                              {viaje.incidencias > 0 && (
                                <Badge variant="destructive" className="text-xs">
                                  {viaje.incidencias}
                                </Badge>
                              )}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Tab: Facturas */}
            <TabsContent value="facturas" className="space-y-6">
              <Card>
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <div>
                      <CardTitle>Mis Facturas</CardTitle>
                      <CardDescription>
                        Gestiona tus facturas y solicita pagos por factoraje
                      </CardDescription>
                    </div>
                    <div className="flex gap-2">
                      <MuiDialog open={showUploadDialog} onClose={() => setShowUploadDialog(false)}>
                        <MuiDialogTitle>Cargar Nueva Factura</MuiDialogTitle>
                        <MuiDialogContent>
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            Sube tu factura para procesamiento y solicitud de pago
                          </Typography>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <TextField
                              type="file"
                              accept=".pdf,.jpg,.jpeg,.png"
                              onChange={handleFileUpload}
                              fullWidth
                              variant="outlined"
                            />
                            <TextField
                              label="Número de Factura"
                              placeholder="Ej: FAC-2024-001"
                              fullWidth
                              variant="outlined"
                            />
                            <TextField
                              label="Monto"
                              placeholder="$0.00"
                              fullWidth
                              variant="outlined"
                            />
                            <TextField
                              label="Cliente"
                              placeholder="Nombre del cliente"
                              fullWidth
                              variant="outlined"
                            />
                          </Box>
                        </MuiDialogContent>
                        <DialogActions>
                          <MuiButton onClick={() => setShowUploadDialog(false)}>
                            Cancelar
                          </MuiButton>
                          <MuiButton onClick={handleUploadFactura} variant="contained">
                            Cargar Factura
                          </MuiButton>
                        </DialogActions>
                      </MuiDialog>
                      <Button onClick={() => setShowUploadDialog(true)}>
                        <Upload className="h-4 w-4 mr-2" />
                        Cargar Factura
                      </Button>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Número</TableHead>
                        <TableHead>Fecha</TableHead>
                        <TableHead>Monto</TableHead>
                        <TableHead>Estatus</TableHead>
                        <TableHead>Cliente</TableHead>
                        <TableHead>Vencimiento</TableHead>
                        <TableHead>Acciones</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {facturas.map((factura) => (
                        <TableRow key={factura.id}>
                          <TableCell className="font-medium">{factura.numero}</TableCell>
                          <TableCell>{factura.fecha}</TableCell>
                          <TableCell className="font-medium">{factura.monto}</TableCell>
                          <TableCell>
                            <Badge className={factura.estatus === 'aprobada' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}>
                              {factura.estatus === 'aprobada' ? 'Aprobada' : 'Pendiente'}
                            </Badge>
                          </TableCell>
                          <TableCell>{factura.cliente}</TableCell>
                          <TableCell>{factura.vencimiento}</TableCell>
                          <TableCell>
                            <div className="flex gap-2">
                              <Button variant="outline" size="sm">
                                <Eye className="h-4 w-4" />
                              </Button>
                              {factura.estatus === 'aprobada' && (
                                <Button variant="outline" size="sm">
                                  <DollarSign className="h-4 w-4" />
                                </Button>
                              )}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Tab: Solicitudes de Pago */}
            <TabsContent value="pagos" className="space-y-6">
              <Card>
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <div>
                      <CardTitle>Solicitudes de Pago por Factoraje</CardTitle>
                      <CardDescription>
                        Gestiona tus solicitudes de pago anticipado
                      </CardDescription>
                    </div>
                    <div className="flex gap-2">
                      <MuiDialog open={showSolicitudDialog} onClose={() => setShowSolicitudDialog(false)}>
                        <MuiDialogTitle>Nueva Solicitud de Pago</MuiDialogTitle>
                        <MuiDialogContent>
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            Solicita un pago anticipado por factoraje
                          </Typography>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <FormControl fullWidth>
                              <InputLabel>Factura</InputLabel>
                              <Select label="Factura">
                                {facturas.filter(f => f.estatus === 'aprobada').map(f => (
                                  <MenuItem key={f.id} value={f.id}>
                                    {f.numero} - {f.monto}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            <TextField
                              label="Monto a solicitar"
                              placeholder="$0.00"
                              fullWidth
                              variant="outlined"
                            />
                            <TextField
                              label="Comentarios"
                              placeholder="Comentarios adicionales..."
                              multiline
                              rows={3}
                              fullWidth
                              variant="outlined"
                            />
                          </Box>
                        </MuiDialogContent>
                        <DialogActions>
                          <MuiButton onClick={() => setShowSolicitudDialog(false)}>
                            Cancelar
                          </MuiButton>
                          <MuiButton onClick={handleSolicitarPago} variant="contained">
                            Solicitar Pago
                          </MuiButton>
                        </DialogActions>
                      </MuiDialog>
                      <Button onClick={() => setShowSolicitudDialog(true)}>
                        <Plus className="h-4 w-4 mr-2" />
                        Nueva Solicitud
                      </Button>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Número</TableHead>
                        <TableHead>Fecha</TableHead>
                        <TableHead>Monto</TableHead>
                        <TableHead>Estatus</TableHead>
                        <TableHead>Factura</TableHead>
                        <TableHead>Comisión</TableHead>
                        <TableHead>Fecha Pago</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {solicitudesPago.map((solicitud) => (
                        <TableRow key={solicitud.id}>
                          <TableCell className="font-medium">{solicitud.numero}</TableCell>
                          <TableCell>{solicitud.fecha}</TableCell>
                          <TableCell className="font-medium">{solicitud.monto}</TableCell>
                          <TableCell>
                            <Badge className={solicitud.estatus === 'aprobada' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}>
                              {solicitud.estatus === 'aprobada' ? 'Aprobada' : 'Pendiente'}
                            </Badge>
                          </TableCell>
                          <TableCell>{solicitud.factura}</TableCell>
                          <TableCell className="text-red-600">{solicitud.comision}</TableCell>
                          <TableCell>{solicitud.fechaPago || '-'}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Tab: Incidencias */}
            <TabsContent value="incidencias" className="space-y-6">
              <Card>
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <div>
                      <CardTitle>Incidencias</CardTitle>
                      <CardDescription>
                        Revisa y gestiona las incidencias de tus viajes
                      </CardDescription>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Viaje</TableHead>
                        <TableHead>Fecha</TableHead>
                        <TableHead>Tipo</TableHead>
                        <TableHead>Descripción</TableHead>
                        <TableHead>Estatus</TableHead>
                        <TableHead>Impacto</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {incidencias.map((incidencia) => (
                        <TableRow key={incidencia.id}>
                          <TableCell className="font-medium">{incidencia.viaje}</TableCell>
                          <TableCell>{incidencia.fecha}</TableCell>
                          <TableCell>
                            <Badge variant="outline">{incidencia.tipo}</Badge>
                          </TableCell>
                          <TableCell>{incidencia.descripcion}</TableCell>
                          <TableCell>
                            <Badge className={incidencia.estatus === 'resuelta' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}>
                              {incidencia.estatus === 'resuelta' ? 'Resuelta' : 'Abierta'}
                            </Badge>
                          </TableCell>
                          <TableCell>{incidencia.impacto}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default TransportistaDashboard; 